export function parseLatLng(geo = "") {
  const match = String(geo || "").match(
    /(-?\d+(\.\d+)?)[,\s)]+(-?\d+(\.\d+)?)/,
  );

  if (!match) return null;

  return {
    lat: match[1],
    lng: match[3],
  };
}

export function googleMapsHref(geo = "") {
  const point = parseLatLng(geo);
  if (!point) return null;

  return `https://www.google.com/maps?q=${encodeURIComponent(
    point.lat,
  )},${encodeURIComponent(point.lng)}&z=15`;
}

export function googleMapsEmbedSrc(geo = "") {
  const point = parseLatLng(geo);
  if (!point) return null;

  return `https://www.google.com/maps?q=${encodeURIComponent(
    point.lat,
  )},${encodeURIComponent(point.lng)}&z=15&output=embed`;
}
